import {createContext, useState, useMemo, useRef} from 'react';
import * as React from 'react';

interface TranslatableResourceFormContextType {
  submitting: boolean;
  setSubmitting(submitting: boolean): void;
  dirty: boolean;
  setDirty(dirty: boolean): void;
  setSave(save: () => Promise<void>): void;
  save(): Promise<void>;
}

export const TranslatableResourceFormContext =
  createContext<TranslatableResourceFormContextType>({
    submitting: false,
    setSubmitting: () => {},
    dirty: false,
    setDirty: () => {},
    setSave: () => {},
    save: async () => {},
  });

export function TranslatableResourceFormProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const saveRef = useRef<() => Promise<void>>();
  const [submitting, setIsSubmitting] = useState(false);
  const [dirty, setIsDirty] = useState(false);

  const setSave = (save: () => Promise<void>) => {
    saveRef.current = save;
  };

  const setSubmitting = (submitting: boolean) => {
    setIsSubmitting(submitting);
  };

  const setDirty = (dirty: boolean) => {
    setIsDirty(dirty);
  };

  const save = async () => {
    if (saveRef.current) {
      await saveRef.current();
    }
  };

  const contextValue = useMemo(
    () => ({
      submitting,
      setSubmitting,
      dirty,
      setDirty,
      save,
      setSave,
    }),
    [submitting, dirty],
  );

  return (
    <TranslatableResourceFormContext.Provider value={contextValue}>
      {children}
    </TranslatableResourceFormContext.Provider>
  );
}
